<div class="fulfillment-window-settings-table-container">
  <div class="table-header">
    <p-iconfield iconPosition="left">
      <p-inputicon>
        <i class="pi pi-search"></i>
      </p-inputicon>
      <input type="text" pInputText placeholder="Search fulfillment types..." (input)="onSearch($event)" />
    </p-iconfield>
  </div>

  <p-table
    [scrollable]="true"
    [value]="filteredSettings()"
    [loading]="isLoading()"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50]"
    [tableStyle]="{ 'min-width': '40rem' }"
  >
    <ng-template pTemplate="header">
      <tr>
        @for (col of columns(); track col.field) {
          <th [pSortableColumn]="col.sortable ? col.field : undefined">
            {{ col.header }}
            @if (col.sortable) {
              <p-sortIcon></p-sortIcon>
            }
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-setting>
      <tr>
        <td>
          <strong>{{ getFulfillmentTypeLabel(setting.fulfillmentType) }}</strong>
        </td>
        <td>{{ setting.offsetMinutes }}</td>
        <td>{{ setting.durationMinutes }}</td>
        <td>
          <div class="action-buttons">
            <p-button
              icon="pi pi-pencil"
              severity="info"
              pTooltip="Edit"
              tooltipPosition="top"
              [text]="true"
              [rounded]="true"
              (onClick)="onEditSettings(setting)"
            ></p-button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="columns().length">
          <div class="empty-state">
            <i class="pi pi-cog large-icon"></i>
            <p>No fulfillment window settings found</p>
            @if (searchTerm()) {
              <small>Try adjusting your search criteria</small>
            }
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  [header]="dialogTitle()"
  [modal]="true"
  [style]="{ width: '30vw' }"
  [draggable]="false"
  [resizable]="false"
  [(visible)]="showDialog"
>
  <div class="dialog-content">
    <div class="form-field">
      <label for="offsetMinutes">Offset Minutes *</label>
      <p-inputNumber
        class="field-input"
        id="offsetMinutes"
        name="offsetMinutes"
        [min]="0"
        [ngModel]="settingsForm.offsetMinutes().value()"
        (ngModelChange)="settingsForm.offsetMinutes().value.set($event)"
      ></p-inputNumber>
      <small class="help-text">Minutes from the start of the window before fulfillment begins</small>
      @if (settingsForm.offsetMinutes().touched() && !settingsForm.offsetMinutes().valid()) {
        <small class="p-error">
          @for (error of settingsForm.offsetMinutes().errors(); track error.kind) {
            {{ error.message }}
          }
        </small>
      }
    </div>

    <div class="form-field">
      <label for="durationMinutes">Duration Minutes *</label>
      <p-inputNumber
        class="field-input"
        id="durationMinutes"
        name="durationMinutes"
        [min]="1"
        [ngModel]="settingsForm.durationMinutes().value()"
        (ngModelChange)="settingsForm.durationMinutes().value.set($event)"
      ></p-inputNumber>
      <small class="help-text">Length of the fulfillment window in minutes</small>
      @if (settingsForm.durationMinutes().touched() && !settingsForm.durationMinutes().valid()) {
        <small class="p-error">
          @for (error of settingsForm.durationMinutes().errors(); track error.kind) {
            {{ error.message }}
          }
        </small>
      }
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Cancel" severity="secondary" [disabled]="saving()" (onClick)="showDialog.set(false)"></p-button>
    <p-button label="Update" [loading]="saving()" [disabled]="!isFormValid()" (onClick)="onSaveSettings()"></p-button>
  </ng-template>
</p-dialog>
